import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import PropSetGql from '@/extensions/shop/store/graphql/queries/PropSet.gql';
import PropSetsGql from '@/extensions/shop/store/graphql/queries/PropSets.gql';
import PropSetsPaginatedGql from '@/extensions/shop/store/graphql/queries/PropSetsPaginated.gql';

import PropSetKeysGql from '@/extensions/shop/store/graphql/queries/PropSetKeys.gql';
import ValidatePropSetKeyGql from '@/extensions/shop/store/graphql/queries/ValidatePropSetKey.gql';

import CreatePropSetGql from '@/extensions/shop/store/graphql/mutations/CreatePropSet.gql';
import UpdatePropSetGql from '@/extensions/shop/store/graphql/mutations/UpdatePropSet.gql';
import DeletePropSetGql from '@/extensions/shop/store/graphql/mutations/DeletePropSet.gql';
import ClonePropSetGql from '@/extensions/shop/store/graphql/mutations/ClonePropSet.gql';

export default {
    validateKey: (key, shopID = null, excludedPropSetID = null) =>
        new Promise((resolve, reject) => {
            let variables = { key };
            if (shopID) variables.shop = parseInt(shopID);
            if (excludedPropSetID) variables.excludedPropSet = parseInt(excludedPropSetID);

            apolloClient
                .query({
                    query: ValidatePropSetKeyGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidatePropSetKey))
                .catch(err => reject(err));
        }),
    fetchKeys: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: PropSetKeysGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_PropSets))
                .catch(err => reject(err));
        }),
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: PropSetsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_PropSets))
                .catch(err => reject(err));
        }),
    fetchPropSetsPaginated: (data, withArticles = false) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            let query = PropSetsPaginatedGql
            if (withArticles) query = PropSetsWithArticlesPaginatedGql

            apolloClient
                .query({
                    query,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_prop_set'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        selection: {
                            type: _.get(data, 'pageInfo.selection.type', 'inclusive'),
                            identifiers: _.get(data, 'pageInfo.selection.identifiers', []),
                        },
                        filters,
                    }
                })
                .then(({ data }) => resolve(data.CO_PropSetsPaginated))
                .catch(err => reject(err));
        }),
    fetchPropSet: (id, shopID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id) };
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: PropSetGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_PropSet))
                .catch(err => reject(err));
        });
    },
    create: (propSet) => {
        if (propSet === undefined) throw new Error('required argument is missing');

        propSet = _.removeDeepByKey(propSet, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreatePropSetGql,
                    variables: { propSet }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_CreatePropSet);
                })
                .catch(err => reject(err));
        });
    },
    update: (propSet) => {
        if (propSet === undefined) throw new Error('required argument is missing');

        propSet = _.removeDeepByKey(propSet, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdatePropSetGql,
                    variables: { propSet }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_UpdatePropSet);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeletePropSetGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeletePropSet);
                })
                .catch(err => reject(err));
        });
    },

    clone: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ClonePropSetGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_ClonePropSet);
                })
                .catch(err => reject(err));
        });
    },
};
